<template lang="pug">
.customer-basic-stat.d-flex
  .customer-data.mt-3
    .item.w-50.pb-3
      .key รายการค้างชำระ
      .value(:class="{'red': data.unpaid.count > 0}")
        | {{ data.unpaid.count }} รายการ
    .item.w-50.pb-3
      .key ยอดค้างชำระ
      .value(:class="{'red': data.unpaid.total > 0}")
        | {{ data.unpaid.total | currency }}
    .item.w-50.pb-3
      .key วงเงินคงเหลือ
      .value(:class="{'red': data.account.remaining_credit < 0}")
        | {{ data.account.remaining_credit | currency }}
    .item.w-50.pb-3
      .key มูลค่าเช็คสูงสุด
      .value
        | {{ data.account.maximum_check_value | currency }}
</template>

<script>
import CustomerPicture from '@/components/customers/CustomerPicture.vue';

export default {
  props: {
    data: {
      default: () => {},
      // default: () => ({
      //   unpaid: {
      //     count: 30,
      //     total: 56000000.00,
      //   },
      //   remaining: 15000,
      //   mostExpensiveCheque: 15000,
      // }),
    },
  },
  components: {
    CustomerPicture,
  },
};
</script>

<style lang="scss">
.customer-basic-stat {
  // ...
  .detail {
    .title {
      font-size: 22px;
    }
    .address {
      color: #6B6C6F;
      font-size: 17px;
    }
  }
}

.customer-data {
  display: flex;
  flex-wrap: wrap;
  .item {
    .key {
      font-size: 15px;
      opacity: 0.5;
      letter-spacing: 1px;
    }
    .value {
      font-size: 17px;
      &.red {
        color: #E11A1A;
        font-weight: 500;
      }
      &.green {
        color: #0DA22E;
        font-weight: 500;
      }
    }
  }
}
</style>
